export default __webpack_public_path__ + "static/media/user-dil.376c6f47.svg";